// Copyright (c) StrangeBee 2024

import React, { ReactElement } from 'react';
import { IconBoolean } from '@Atoms/Info/IconBoolean/IconBoolean';
import { useLocalMessage } from '@Helpers/locale';
import { ICONS } from '@Constants/iconsApp';
import { HTMLColors } from '@Constants/colors';

interface IsIgnoreSimilarityProps {
    value?: boolean;
    onChange?: (value: boolean) => void;
    readOnly?: boolean;
    onClick?: () => void;
}

export const IsIgnoreSimilarity = ({
    value,
    onChange,
    onClick,
    readOnly = false,
}: IsIgnoreSimilarityProps): ReactElement => {
    const i = useLocalMessage();

    return (
        <IconBoolean
            icon={<ICONS.IgnoreSimilarityTrue />}
            value={!!value}
            onClick={(): void => {
                onClick?.();
                onChange?.(!value);
            }}
            readOnly={readOnly}
            onTrue={{ icon: <ICONS.IgnoreSimilarityTrue />, color: HTMLColors.BLUE }}
            onFalse={{ icon: <ICONS.IgnoreSimilarityFalse />, color: HTMLColors.GRAY }}
            label={i('common.ignore-similarity')}
        />
    );
};
